import React, { Component } from "react";
import classes from "./login.css";
import axios from "axios";
import { backendBaseUri } from "../../uri";

class LogIn extends Component {
    state = {
        userName: "",
        password: "",
        loginError: false,
    };

    updateUserName(evt) {
        this.setState({
            userName: evt.target.value,
        });
    }

    updatePassword(evt) {
        this.setState({
            password: evt.target.value,
        });
    }

    onSubmit = (e) => {
        e.preventDefault();
        // Save State & History
        const { userName, password } = this.state;
        const { history } = this.props;

        // Post userName / password to Api for auth
        axios
            .post(
                `${backendBaseUri}/auth/login`,
                {
                    name: userName,
                    password: password,
                },
                {
                    headers: {
                        "content-type": "application/json",
                    },
                },
            )
            .then((res) => {
                // Save token to cookie
                const token = res.headers["x-auth"];
                localStorage.setItem("token", token);
                history.push("/consents");
            })
            .catch((err) => {
                console.log(err);
                this.setState({
                    loginError: true,
                });
            });
    };

    displayError() {
        if (this.state.loginError) {
            return (
                <p className={classes.loginError}>
                    Username or password are incorrect. Please try again.
                </p>
            );
        }
    }

    render() {
        return (
            <div className={classes.Container}>
                <form className={classes.LogInForm}>
                    <img
                        src={require("../../assets/logos/implantoralsurgeryLogo.png")}
                        className={classes.Logo}
                        alt=""
                    />
                    <input
                        type="text"
                        placeholder="Username"
                        className={classes.Fields}
                        value={this.state.userName}
                        onChange={(evt) => this.updateUserName(evt)}
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        className={classes.Fields}
                        value={this.state.password}
                        onChange={(evt) => this.updatePassword(evt)}
                    />
                    <button
                        className={classes.LogInButton}
                        onClick={(e) => this.onSubmit(e)}
                        type="primary"
                    >
                        LOGIN
                    </button>
                    {this.displayError()}
                </form>
            </div>
        );
    }
}

export default LogIn;



// WEBPACK FOOTER //
// ./src/containers/LogIn/LogIn.js